module.exports = __webpack_public_path__ + "img/fangtan1-2.3caef6f7.png";